export const getStrippedEntityId = id => id.split('/').pop();
export const setGraphqlVacancyId = id => `/vacancies/${id}`;
export const setGraphqlVacancyAlertId = id => `/vacancy_alerts/${id}`;
export const setGraphqlEducationLevelsId = id => `/education_levels/${id}`;
export const setGraphqlUserId = id => `/users/${id}`;
